import {
  type WebshopUserCapiCategoryPageViewEvent,
  type WebshopUserCapiInitiateCheckoutEvent,
  type WebshopUserCapiPageViewEvent,
  type WebshopUserCapiProductPageViewEvent,
  type WebshopUserCapiSubscribeEvent,
  WebshopUserEndpoints,
  webshopUserCapiCategoryPageViewService,
  webshopUserCapiInitiateCheckoutService,
  webshopUserCapiPageViewService,
  webshopUserCapiProductPageViewService,
} from '@cldsystems/ws-api-client';

import { runtimeHttpClient } from '@/services/services.setup';
import { hasCapiMarketingConsent } from '@/utils/capi-event';

const CAPI_REQUEST = { params: {}, queries: {} } as const;

const postIfConsented = <T>(post: () => Promise<T>): undefined | Promise<T> => {
  if (!hasCapiMarketingConsent()) {
    return;
  }

  return post();
};

export const postCapiPageView = (payload: WebshopUserCapiPageViewEvent) =>
  postIfConsented(() =>
    webshopUserCapiPageViewService({
      httpClient: runtimeHttpClient,
      hasSchema: false,
      payload,
    })(CAPI_REQUEST),
  );

export const postCapiProductPageView = (payload: WebshopUserCapiProductPageViewEvent) =>
  postIfConsented(() =>
    webshopUserCapiProductPageViewService({
      httpClient: runtimeHttpClient,
      hasSchema: false,
      payload,
    })(CAPI_REQUEST),
  );

export const postCapiCategoryPageView = (payload: WebshopUserCapiCategoryPageViewEvent) =>
  postIfConsented(() =>
    webshopUserCapiCategoryPageViewService({
      httpClient: runtimeHttpClient,
      hasSchema: false,
      payload,
    })(CAPI_REQUEST),
  );

export const postCapiInitiateCheckout = (payload: WebshopUserCapiInitiateCheckoutEvent) =>
  postIfConsented(() =>
    webshopUserCapiInitiateCheckoutService({
      httpClient: runtimeHttpClient,
      hasSchema: false,
      payload,
    })(CAPI_REQUEST),
  );

// Raw fetch with keepalive (axios has none) so a MailerLite redirect-on-success
// can't cancel the request mid-flight.
export const postCapiSubscribe = (payload: WebshopUserCapiSubscribeEvent) =>
  postIfConsented(() =>
    fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}${WebshopUserEndpoints.CapiSubscribe}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      keepalive: true,
      body: JSON.stringify(payload),
    }),
  );
